import { LabelValueRow } from 'components/core-v2'
import React from 'react'
import { formatCurrencyFull } from 'utilities/currency'
import { formatUnits } from 'utilities/number'

import { CURRENCY } from '../../../const'
import { ConfirmedOrder, isBuyOrder } from '../orders-detail/orders-types'
import classes from './order-confirmed.module.scss'

interface ConfirmedProps {
  order: ConfirmedOrder
}

export const getTotal = (order: ConfirmedOrder) =>
  isBuyOrder(order) ? order.value : Math.abs(order.shares * (order.executionPrice / 100))

export const getUnits = (order: ConfirmedOrder) =>
  isBuyOrder(order) ? order.value / (order.executionPrice / 100) : Math.abs(order.shares)

export const OrderConfirmed = ({ order }: ConfirmedProps) => (
  <div className={classes.root}>
    <LabelValueRow
      className={classes.firstRow}
      label="Confirmed"
      value={new Date(order.confirmedDate).toLocaleDateString(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })}
    />
    <LabelValueRow label="Confirmed by" value={order.confirmationAuthor} />
    <LabelValueRow label="Number of units" value={formatUnits(getUnits(order))} />
    <LabelValueRow
      label="Price per unit"
      value={formatCurrencyFull(order.executionPrice, CURRENCY, null, true)}
    />
    <LabelValueRow label="Total amount" value={formatCurrencyFull(getTotal(order), CURRENCY)} />
  </div>
)
